import { Header } from "./Header";
import { Footer } from "./Footer";
import { MessageArea } from "./MessageArea";
import { AdminPanel } from "./AdminPanel";
import { AdminService } from "../../services/AdminService";
import { FooterMainButton } from "./FooterMainButton";
import { usePageElements } from "../../hooks/usePageElements";

export interface IBasePage {
  children: any;
}
export const BasePage = ({ children }: IBasePage) => {
  const { baseElement } = usePageElements();
  return (
    <div>
      <div className="container" ref={baseElement}>
        {/* <Header /> */}
        <MessageArea />
        {children}
        <Footer />
      </div>
    </div>
  );
};
